<template>

<div class="contact-form">
    <div class="contact-form__form">
      <form name="contact-form" method="POST" class="contact__form" netlify-honeypot="bot-field" data-netlify="true" @submit="submitForm($event)">
        <input type="hidden" name="form-name" value="Contact" />
          <p style="display: none" class="hidden">
          <label>Don’t fill this out if you're human: <input name="bot-field" /></label>
        </p>
        <div class="contact-form__name">
          <Input :placeholder="name.placeholder" :name="name.name" v-model="name.value" :class="{ 'error' : !name.valid }"/>
        </div>

        <div class="contact-form__email-wrap" >
          <Input :placeholder="email.placeholder" :name="email.name" v-model="email.value" :class="{ 'error' : !email.valid }"/>
        </div>

        <div class="contact-form__message-wrap">
          <label>
            <TextArea aria-label="message" :required=true :placeholder="message.placeholder" :name="message.name" v-model="message.value" :rows="message.rows" :class="{ 'error' : !message.valid }" />
          </label>
        </div>
        <input type="submit" value="Submit" class="app-btn--simple">
      </form>
    </div>
  </div>
</template>

<script>
import Input from '@/components/UI/InputText.vue';
import TextArea from '@/components/UI/TextArea.vue';

export default {
  name: 'Contact',
  props: {
    isFormValid: Boolean,
  },
  data() {
    return {
      name: {
        value: '',
        name: 'name',
        placeholder: 'Name',
        valid: true,
        required: true,
      },
      email: {
        value: '',
        name: 'email',
        required: true,
        placeholder: 'Email',
        valid: true,
      },
      message: {
        value: '',
        name: 'message',
        required: true,
        valid: true,
        placeholder: 'Write us a message',
        rows: 7,
      },
    };
  },
  components: {
    Input,
    TextArea,
  },
  methods: {
    validEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      console.log(re.test(email));
      return re.test(email);
    },
    validate() {
      let counterErrors = 0;
      if (this.name.required && this.name.value === '') {
        counterErrors += 1;
        this.name.valid = false;
      } else {
        this.name.valid = true;
      }

      if (this.email.required && !this.validEmail(this.email.value)) {
        counterErrors += 1;
        this.email.valid = false;
      } else {
        this.email.valid = true;
      }

      if (this.message.required && this.message.value === '') {
        counterErrors += 1;
        this.message.valid = false;
      } else {
        this.message.valid = true;
      }

      console.log(counterErrors);

      if (counterErrors === 0) {
        const data = {
          name: this.name.value,
          email: this.email.value,
          message: this.message.value,
        };

        return data;
      }
      return null;
    },
    sendNetlifyRequest(data) {
      fetch('/', {
        method: 'post',
        headers: {
          Accept: 'application/x-www-form-urlencoded;charset=UTF-8',
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: new URLSearchParams(data).toString(),
      }).then((response) => {
        if (response.ok) {
          console.log('message sent!');
        } else {
          console.log('message not sent!');
        }
      }).catch((err) => {
        console.log('error!', err);
      });
    },
    submitForm(event) {
      event.preventDefault();
      const isValid = this.validate();
      if (isValid) {
        this.$emit('update', true);
        this.sendNetlifyRequest(isValid);
        this.clearFields();
      } else {
        this.$emit('update', false);
      }
    },

    clearFields() {
      this.name.value = '';
      this.email.value = '';
      this.message.value = '';
    },
  },

  deactivated: function () {
    this.clearFields();
  },
};
</script>
